import './bootstrap';
import 'admin-lte';

import { createApp,shallowRef,  ref, computed  } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import axios from 'axios';

/*
 * Vuetify убран 11.08. Его использовали только страница «Реклама» (удалена,
 * её заменили «Добавить материал», «Контент» и вкладка «Эфир») и один блок
 * радио-кнопок в FormWidget — там теперь обычная разметка. Это был самый
 * тяжёлый груз в бандле, а тянул его на каждой загрузке и планшет в клубе,
 * которому админка не нужна вовсе.
 *
 * Если Vuetify понадобится снова, подключать его стоит точечно в нужный
 * компонент, а не глобально на всё приложение.
 */

import  Form  from 'vform';
window.Form = Form;
//const form = new Form({ ... }

// vue-select остаётся: на нём держатся выпадающие списки в «Пользователях»
// (признак — проп :reduce, которого у Vuetify нет).
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

//Widget
import RightModalWidget from './components/widgets/RightModalWidget.vue'
import InfoWidget from './components/widgets/InfoWidget.vue'
import SearchWidget from './components/widgets/SearchWidget.vue'
import EditListWidget from './components/widgets/EditListWidget.vue'
import DropInput from './components/widgets/DropInput.vue'

//Page

import Footer from './components/footer.vue'

import {Bootstrap4Pagination} from 'laravel-vue-pagination'

import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

//Page

//import login from './components/page/auth/Login.vue'

import Gate from "./Gate";
import routes from './routes';

import Swal from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const router = createRouter({
	routes,
	history: createWebHistory()
})


const app = createApp({
	data() {
		return {
			menu_right: '1',
		 }
	 }
	}
);

app.config.globalProperties.$gate = new Gate(window.user);
app.config.globalProperties.$axios = axios;


app.component("v-select", vSelect);
app.component('pagination', Bootstrap4Pagination)

app.component('footers-page', require('./components/footer.vue').default)
app.component('info-widget', InfoWidget)
app.component('drop-widget', DropInput)
app.component('right-modal-widget', RightModalWidget)
app.component('search-widget', SearchWidget)
app.component('editlist-widget', EditListWidget)


//app.use(ToastPlugin);
app.use(ToastPlugin, {
	position: 'top-right'
})
app.use(router);
app.use(Swal);
//app.use(vSelect);
window.Swal =  app.config.globalProperties.$swal;


var vm = app.mount('#app')


